import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'
import { fontSize, size } from '@twistopayments/design-system/styles'

export const button = (theme: Theme) => css`
  & a {
    box-sizing: border-box;
    border-radius: ${theme.borderRadius.sm};
    padding: ${size[18]} ${size[40]};
  }

  & span {
    font-size: ${fontSize.sm};
    font-weight: 500;
  }
`

export const iconButton = (theme: Theme) => css`
  & a {
    box-sizing: border-box;
    border-radius: ${theme.borderRadius.md};

    span {
      display: flex;
      align-items: center;
      gap: ${size[12]};
    }
  }
`
